import { fetch, ListEntityResponse } from "..";
import { QueryMethod } from '../utils';
import { NotificationDto } from "./dto";

export async function findAllNotifications() {
  return fetch<ListEntityResponse<NotificationDto>>(
    `/v1/notification?page=1&limit=200&sort=voucherStatus&order=asc`,
    QueryMethod.GET
  );
}

export async function markNotificationAsRead(id: number): Promise<void> {
  return fetch(`/v1/notification/mark-as-read/${id}`, QueryMethod.POST);
}
